export const NosaMark = ({ className = "h-9 w-9" }) => (
  <img
    src="/images/logo-mark.png"
    alt=""
    aria-hidden="true"
    className={`${className} w-auto object-contain`}
  />
);

export default function NosaLogo({ compact = false }) {
  return (
    <a
      href="#top"
      data-testid="nav-logo-link"
      onClick={(e) => {
        e.preventDefault();
        window.__lenis
          ? window.__lenis.scrollTo(0, { duration: 1.4 })
          : window.scrollTo({ top: 0, behavior: "smooth" });
      }}
      className="group flex items-center gap-3"
      aria-label="NOSA Pet Food — începutul paginii"
    >
      <img
        src="/images/logo-mark.png"
        alt="NOSA Pet Food"
        className="h-11 w-auto object-contain transition-transform duration-500 group-hover:scale-105"
      />
      {!compact && (
        <span className="flex flex-col leading-none">
          <span className="font-serif text-2xl tracking-[0.28em] text-cream">
            NOSA
          </span>
          <span className="mt-1 font-mono text-[9px] uppercase tracking-[0.42em] text-gold">
            Pet Food
          </span>
        </span>
      )}
    </a>
  );
}
